import axios from 'axios'

export default {
	load (params = {}) {
		return axios.get('/api/modules', { params })
	}
}
